export function getMask(str: string) {
  const len = str.length;

  if (len >= 10) {
    return '+7 000 000-00-00';
  } else if (len >= 8) {
    return '+7 000 000-00 00';
  } else {
    return '+7 000 000 00 00';
  }
}
